import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Content } from '@/components/layout/Content';
import { LoadingPage } from '@/components/LoadingPage';
import { useQuery } from '@/hooks/graphql/useQuery';
import { Report } from './parts/Report';
import { REGULAR_HEALTH_CHECKUP_REPORT } from './query';

interface ShowReportParams {
  id: string;
}

export const ShowReports: FC = () => {
  const { id } = useParams<ShowReportParams>();
  const { data } = useQuery(REGULAR_HEALTH_CHECKUP_REPORT, {
    variables: { id: parseInt(id, 10) },
    fetchPolicy: 'no-cache'
  });

  const regularHealthCheckupReport = data?.regularHealthCheckupReport;

  if (!regularHealthCheckupReport) {
    return <LoadingPage />;
  }

  return (
    <div>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">定期健康診断結果報告書詳細</h1>
      </div>
      <Content size="xl-4">
        {regularHealthCheckupReport ? (
          <>
            <Report report={regularHealthCheckupReport} />
          </>
        ) : (
          <LoadingPage />
        )}
      </Content>
    </div>
  );
};
